// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createStoreReviews = (client) => ({
    /**
     * `POST /store/reviews`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreCreateNewReview
     * @source packages/modules/reviews/src/api/store/reviews/route.ts
     */
    create: (body, query, headers) => client.fetch("/store/reviews", { method: "POST", body, query, headers }),
    /**
     * `DELETE /store/reviews/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreDeleteReviewById
     * @source packages/modules/reviews/src/api/store/reviews/[id]/route.ts
     */
    delete: (id, body, query, headers) => client.fetch(buildPath("/store/reviews/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /store/reviews`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreGetMyReviews
     * @source packages/modules/reviews/src/api/store/reviews/route.ts
     */
    list: (query, headers) => client.fetch("/store/reviews", { method: "GET", query, headers }),
    /**
     * `GET /store/reviews/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreGetReviewById
     * @source packages/modules/reviews/src/api/store/reviews/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/store/reviews/:id", [id]), { method: "GET", query, headers }),
    /**
     * `POST /store/reviews/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreUpdateReviewById
     * @source packages/modules/reviews/src/api/store/reviews/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/store/reviews/:id", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=reviews.js.map